import { Group, Paper, Stack } from '@mantine/core'
import { useIntl } from 'react-intl'

import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import TanksDataTable from '../../../components/alvic/TanksDataTable'
import TanksService from '../../../services/alvic/tanks/tanks.service'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import './tanks.scss'

const Tanks = () => {
  const { formatMessage: msg } = useIntl()

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'purchaseMade',
    sortInit: -1,
    getAll: TanksService.getAll,
  })

  const legendTemplate = (centerName) => (
    <h5 className="center-name">{centerName}</h5>
  )

  const headerOptions = {
    title: msg({ id: 'tanks' }),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.getAll?.total,
  }

  const dataTable = (
    <Stack w="100%" gap="xl" pb="xl">
      {dataFacade?.data?.resp?.map((ownStation) => (
        <Group w="100%" className="ownStation">
          <Paper w="100%">
            {legendTemplate(ownStation?.centerName)}
            <TanksDataTable
              value={ownStation?.tanks}
              pagerOptions={pagerOptions}
            />
          </Paper>
        </Group>
      ))}
    </Stack>
  )

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={fuelStationsMenu} />}
      headerOptions={headerOptions}
      dataFacade={dataFacade}
    >
      {dataTable}
    </AppSection>
  )
}

export default Tanks
